<script>
    import { Bar } from 'vue-chartjs';

    export default {
        extends: Bar,

        props: {
            stats: {
                type: Array,
                required: true,
            },
            color: {
                type: String,
                default: '200,0,0',
            },
        },

        methods: {
            async chartData() {
                return {
                    labels: this.stats.map(row => row.value),
                    datasets: [
                        {
                            data: this.stats.map(row => Math.round((100 / row.total) * row.result)),
                        },
                    ],
                };
            },

            async update() {
                const data = await this.chartData();

                this.renderChart(
                    data,
                    {
                        aspectRatio: 4,
                        maintainAspectRatio: false,
                        legend: {
                            display: false,
                        },
                        elements: {
                            rectangle: {
                                backgroundColor: `rgba(${this.color},0.7)`,
                                borderWidth: 2,
                                borderColor: `rgba(${this.color},1)`,
                            },
                        },
                        scales: {
                            yAxes: [{
                                ticks: {
                                    min: 0,
                                    max: 100,
                                },
                            }],
                        },
                    },
                );
            },
        },

        mounted() {
            this.update();
        },

        watch: {
            stats() {
                this.update();
            },
        },
    };
</script>
